import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { IcFileInvoiceDollar, IcPlus, IcChartPie, IcPdf, IcAt, IcExcel, IcCheckCircle, IcHourglass, IcChartLine, IcEdit, IcDollar, IcSave, IcReceipt } from "../../Icons";
import { TableHeader, Pagination, Search } from "../../DataTable";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import axios from "axios";
import {
  Table,
  Button,
  Col,
  Row,
  Label,
  Input,
  ButtonGroup,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Spinner,
} from "reactstrap";
import Header from "../../layout/Header/Header";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import { pdfHeader, pdfFooter, pdfTableStyles } from "../../../pdfUtils";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import moment from "moment";

function ListadoCargos() {
  let hoy = new Date();
// Obtener el primer día del mes en curso
let inicio = new Date(hoy.getFullYear(), hoy.getMonth(), 1);

  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_CARGOS = process.env.REACT_APP_URL_CARGOS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_ABONOS = process.env.REACT_APP_URL_ABONOS;

  const [cargos, setCargos] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [clientesEdit, setClientesEdit] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [selectedCategoria, setSelectedCategoria] = useState("");
  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);
  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");
  const [value, setValue] = useState();
  const [valueEdit, setValueEdit] = useState();
  const [validaBoton, setValidaBoton] = useState(true);

  const [text, setText] = useState(false);

  const [selectedClienteEdit, setSelectedClienteEdit] = useState("");
  const [fecha, setFecha] = useState("");
  const [importe, setImporte] = useState("");
  const [importeViejo, setImporteViejo] = useState("");
  const [abonosEdit, setAbonosEdit] = useState(0);
  const [descripcion, setDescripcion] = useState("");
  const [IdEditCargo, setIdEditCargo] = useState("");
  const [categoriaEdit, setCategoriaEdit] = useState("Otros");
  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);
  const [refreshCount,  setRefreshCount]  = useState(0);
  const [modalCreate,   setModalCreate]   = useState(false);
  const toggleCreate = () => setModalCreate(!modalCreate);
  const [cFecha,        setCFecha]        = useState(moment(new Date()).format("YYYY-MM-DD"));
  const [cImporte,      setCImporte]      = useState("");
  const [cDescripcion,  setCDescripcion]  = useState("");
  const [cCategoria,    setCCategoria]    = useState("Mensualidad");
  const [cCliente,      setCCliente]      = useState("");

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  // Quick pay
  const [modalAbonar, setModalAbonar] = useState(false);
  const [abonarCargo, setAbonarCargo]       = useState(null);
  const [abonarFecha, setAbonarFecha]       = useState(moment().format("YYYY-MM-DD"));
  const [abonarImporte, setAbonarImporte]   = useState("");
  const [abonarFormaPago, setAbonarFormaPago] = useState("Efectivo");
  const toggleAbonar = () => setModalAbonar(!modalAbonar);

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  // function jalaFechas (){

  //   const Toast = Swal.mixin({
  //     toast: true,
  //     position: 'center',
  //     showConfirmButton: false,
  //     timer: 4000,
  //     timerProgressBar: true,
  //     didOpen: (toast) => {
  //       toast.addEventListener('mouseenter', Swal.stopTimer)
  //       toast.addEventListener('mouseleave', Swal.resumeTimer)
  //     }
  //   })

  //   Toast.fire({
  //     icon: 'success',
  //     title: 'Danos unos segundos....'
  //   })

  // }

  useMemo(() => {
    axios
      .get(`${URL_CARGOS}/fechas/${selectedFechaInicio}/${selectedFechaFin}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allCargos = response.data;
        let arrayTabla = allCargos
          .sort((a, b) => (a.fecha < b.fecha ? 1 : -1))
          .map((a) => {
            return {
              _id: a._id,
              fecha: a.fecha,
              cliente: a.clientes[0].nombre_comercial,
              idCliente: a.clientes[0]._id,
              importe: a.importe,
              saldo: a.saldo ?? a.importe,
              abonos: a.abonos ?? 0,
              descripcion: a.descripcion,
              numero: a.idCargo,
              categoria: a.categoria || "Otros",
            };
          })
          .filter(function (el) {
            return el != null;
          });
        let dataFinal = Object.values(arrayTabla);
        setComments(dataFinal);
        setCargos(allCargos);
      })
      .catch((err) => {
      });

    axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allClientes = res.data;
        setClientes(allClientes);
      })
      .catch((err) => {
      });
  }, [selectedFechaInicio, selectedFechaFin, refreshCount]); // eslint-disable-line

  function saveCargo() {
    if (!cCliente || !cFecha || !cImporte || !cDescripcion) {
      return Swal.fire({ icon: "warning", title: "Completa todos los campos requeridos" });
    }
    const imp = Number(cImporte);
    axios.post(URL_CARGOS, {
      mensualidad: "NA", fecha: cFecha, descripcion: cDescripcion,
      importe: imp, categoria: cCategoria, clientes: cCliente, abonos: 0, saldo: imp,
    }, { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } })
      .then(() => {
        setCFecha(moment(new Date()).format("YYYY-MM-DD"));
        setCImporte(""); setCDescripcion(""); setCCategoria("Mensualidad"); setCCliente("");
        setModalCreate(false);
        setRefreshCount((p) => p + 1);
        Swal.fire({ icon: "success", title: "Cargo creado", timer: 1500, showConfirmButton: false });
      })
      .catch(() => Swal.fire({ icon: "error", title: "Error al guardar" }));
  }

  let total = 0;
  let totalAbonos = 0;
  let totalSaldo  = 0;

  function PDFTabla() {
    const logo = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    total = 0;
    const data = cargos.map((c) => {
      if (
        (selectedCliente == 0 || selectedCliente == c.clientes[0]._id) &&
        (selectedFechaInicio == 0 || selectedFechaInicio <= c.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= c.fecha)
      ) {
        total = total + c.importe;
        return [
          c.fecha,
          [c.clientes[0].nombre_comercial],
          "$" + new Intl.NumberFormat("en-US").format(c.importe),
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    const startY = pdfHeader(doc, "Listado de Cargos", `${selectedFechaInicio} — ${selectedFechaFin}`);
    doc.autoTable({
      ...pdfTableStyles(),
      head: [["Fecha", "Cliente", "Importe"]],
      body: dataPDFLimpia,
      startY,
      foot: [["", "Total", "$" + new Intl.NumberFormat("en-US").format(total)]],
      showFoot: "lastPage",
    });
    pdfFooter(doc);
    doc.save("ListadoCargos.pdf");
  }

  function excel() {
    const dataExcel = cargos.map((c) => {
      if (
        (selectedCliente == 0 || selectedCliente == c.clientes[0]._id) &&
        (selectedFechaInicio == 0 || selectedFechaInicio <= c.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= c.fecha)
      ) {
        return {
          Fecha: c.fecha,
          Cliente: c.clientes[0].nombre_comercial,
          Importe: c.importe,
        };
      }
    });

    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoCargos";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoCargos",
        sheetFilter: ["Fecha", "Cliente", "Importe"],
        sheetHeader: ["Fecha", "Cliente", "Importe"],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const logo = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    total = 0;
    const data = cargos.map((c) => {
      if (
        (selectedCliente == 0 || selectedCliente == c.clientes[0]._id) &&
        (selectedFechaInicio == 0 || selectedFechaInicio <= c.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= c.fecha)
      ) {
        total = total + c.importe;
        return [
          c.fecha,
          c.clientes[0].nombre_comercial,
          "$" + new Intl.NumberFormat("en-US").format(c.importe),
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    const startY = pdfHeader(doc, "Listado de Cargos", `${selectedFechaInicio} — ${selectedFechaFin}`);
    doc.autoTable({
      ...pdfTableStyles(),
      head: [["Fecha", "Cliente", "Importe"]],
      body: dataPDFLimpia,
      startY,
      foot: [["", "Total", "$" + new Intl.NumberFormat("en-US").format(total)]],
      showFoot: "lastPage",
    });
    pdfFooter(doc);
    var att = doc.output("arraybuffer");
    var base64File = encode.encode(att, "base64");

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Cargos",
          email: mailTo,
          fileName: "Listado-Cargos.pdf",
          att: base64File,
          text: `<!DOCTYPE html>
         <html>
           <head>
             <style>                                
               .img-container {
                               display: block;
                               margin-left: auto;
                               margin-right: auto;
                               height: 90px;
                               width: auto;
                             }
             </style>
           </head>
           <body>
             <img class="img-container" alt="Logo" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" />              
             <h1>${process.env.REACT_APP_NOMBRE_INSTITUCION}</h1>
             <h3>Hola,</h3>
             <h3>Adjunto encontraras el listado de cargos.</h3>
             <h4>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</h4>
             Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> 
           </body>
         </html>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
      });
  }

  function editCargo(event) {
    event.preventDefault();
    setValidaBoton(false);
    axios
      .patch(
        `${URL_CARGOS}/${IdEditCargo}`,
        { fecha, descripcion, importe, categoria: categoriaEdit, saldo: Number(importe) - abonosEdit },
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      )
      .then(() => {
        // Actualiza el registro en el state local — sin recargar página
        setComments((prev) =>
          prev.map((c) =>
            c._id === IdEditCargo
              ? { ...c, fecha, descripcion, importe: Number(importe), categoria: categoriaEdit, saldo: Number(importe) - abonosEdit }
              : c
          )
        );
        axios.post(
          URL_LOGS,
          { tipo: "Editar Cargo", detalle: descripcion, user: user.id },
          { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
        );
        toggleEdit();
        setValidaBoton(true);
        Swal.fire("¡Listo!", "Cargo actualizado", "success");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response?.data}`,
        });
        setValidaBoton(true);
      });
  }

  function jalaInfo(idEdit, cliente) {
    setClientesEdit(cliente)
    const URL_CARGOS_EDIT = `${process.env.REACT_APP_URL_CARGOS}/${idEdit}`;
    axios
      .get(URL_CARGOS_EDIT, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        setFecha(response.data.fecha);
        setDescripcion(response.data.descripcion);
        setImporte(response.data.importe);
        setImporteViejo(response.data.importe);
        setAbonosEdit(response.data.abonos ?? 0);
        setCategoriaEdit(response.data.categoria || "Otros");
        setSelectedClienteEdit(response.data.clientes[0]._id);
        setIdEditCargo(idEdit);
        toggleEdit();
      })
      .catch((err) => {
      });
  }


  function abrirModalAbonar(c) {
    setAbonarCargo(c);
    setAbonarImporte(c.saldo > 0 ? c.saldo : c.importe);
    setAbonarFecha(moment().format("YYYY-MM-DD"));
    setAbonarFormaPago("Efectivo");
    toggleAbonar();
  }

  async function guardarAbono(e) {
    e.preventDefault();
    setValidaBoton(false);
    try {
      await axios.post(
        URL_ABONOS,
        {
          fecha: abonarFecha,
          importe: parseFloat(abonarImporte),
          clientes: abonarCargo.idCliente,
          cargos: abonarCargo._id,
          formaPago: abonarFormaPago,
          concepto: "Abono",
          comisionPagada: "No",
          observaciones: "NA",
          aplicado: "No",
        },
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      );
      await axios.patch(
        `${URL_CARGOS}/${abonarCargo._id}`,
        {
          saldo: (abonarCargo.saldo ?? abonarCargo.importe) - parseFloat(abonarImporte),
          abonos: (abonarCargo.abonos ?? 0) + parseFloat(abonarImporte),
        },
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      );
      axios.post(
        URL_LOGS,
        { tipo: "Abono desde Cargos", listado: abonarCargo._id, user: user.id },
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      );
      toggleAbonar();
      Swal.fire("Listo!", "Abono registrado con éxito", "success");
      setTimeout(() => window.location.reload(), 1000);
    } catch {
      Swal.fire({ icon: "error", title: "Error", text: "No se pudo registrar el abono" });
    } finally {
      setValidaBoton(true);
    }
  }

  const headers = [
    { name: "Fecha",      field: "fecha",      sortable: true },
    { name: "Cliente",    field: "cliente",    sortable: true  },
    { name: "Categoría",  field: "categoria",  sortable: true  },
    { name: "Importe",    field: "importe",    sortable: true  },
    { name: "Abonos",     field: "abonos",     sortable: true  },
    { name: "Saldo",      field: "saldo",      sortable: true  },
    { name: "Acciones",   field: "acciones",   sortable: false },
  ];

  const summaryStats = useMemo(() => {
    const fmtI        = (v) => "$" + new Intl.NumberFormat("en-US").format(Math.round(v || 0));
    const totalImporte = comments.reduce((s, c) => s + (Number(c.importe) || 0), 0);
    const totalAbonos  = comments.reduce((s, c) => s + (Number(c.abonos)  || 0), 0);
    const totalSaldo   = comments.reduce((s, c) => s + (Number(c.saldo)   || 0), 0);
    const cobPct       = totalImporte > 0 ? (totalAbonos / totalImporte * 100) : 0;
    return {
      count:        comments.length,
      totalImporte: fmtI(totalImporte),
      totalAbonos:  fmtI(totalAbonos),
      totalSaldo:   fmtI(totalSaldo),
      cobPct:       cobPct.toFixed(1),
      cobColor:     cobPct >= 80 ? "#10b981" : cobPct >= 50 ? "#f59e0b" : "#ef4444",
      cobBg:        cobPct >= 80 ? "#f0fdf4" : cobPct >= 50 ? "#fffbeb" : "#fff1f2",
    };
  }, [comments]);

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter((comment) =>
        comment.cliente.toLowerCase().includes(search.toLowerCase())
      );
    }

    if (selectedCliente) {
      computedComments = computedComments.filter((e) =>
        e.idCliente.includes(selectedCliente)
      );
    }

    if (selectedCategoria) {
      computedComments = computedComments.filter((e) =>
        e.categoria === selectedCategoria
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (sorting.field) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      const numericFields = ["importe", "abonos", "saldo"];
      if (numericFields.includes(sorting.field)) {
        computedComments = computedComments.sort(
          (a, b) => reversed * ((Number(a[sorting.field]) || 0) - (Number(b[sorting.field]) || 0))
        );
      } else {
        computedComments = computedComments.sort(
          (a, b) => reversed * String(a[sorting.field]).localeCompare(String(b[sorting.field]))
        );
      }
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [comments, currentPage, search, sorting, selectedCliente, selectedCategoria]);

  async function migraCategorias() {
    const confirm = await Swal.fire({
      title: "¿Migrar categorías?",
      html: "Clasificará todos los cargos existentes:<br/><b>Mensualidad</b> → del cron o descripción con 'Mensualidad'/'Anualidad'<br/><b>Setup</b> → descripción contiene 'Setup'<br/><b>Otros</b> → el resto<br/><br/>Solo necesitas ejecutarlo <b>una vez</b>.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, migrar",
      cancelButtonText: "Cancelar",
    });
    if (!confirm.isConfirmed) return;
    try {
      const res = await axios.post(
        `${URL_CARGOS}/dev/updateCategorias`,
        {},
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      );
      Swal.fire("¡Listo!", `${res.data.message}<br/>Mensualidad: ${res.data.mensualidad}<br/>Setup: ${res.data.setup}<br/>Otros: ${res.data.otros}`, "success");
      setTimeout(() => window.location.reload(), 1500);
    } catch {
      Swal.fire({ icon: "error", title: "Error", text: "No se pudo completar la migración" });
    }
  }

  async function PDFOC(
    fecha,
    clientes,
    importe,
    numero
  ) {
        const doc = new jsPDF();
        const startY = pdfHeader(doc, "Cargo");
        doc.autoTable({
          ...pdfTableStyles(),
          head: [
            [
              "Fecha",
              "Cliente",
              "Importe",
            ],
          ],
          body: [[
            fecha,
            clientes,
            "$" + new Intl.NumberFormat("en-US").format(importe)
          ]],
          startY,
        });
        doc.setFontSize(10);
        doc.text(`Agradecemos tu pago antes del dia 5 del mes.`,15,70);
        doc.text(`Ayúdanos a continuar el servicio de calidad que nos caracteriza.`,15,75);

        pdfFooter(doc);
        doc.save(`Cargo.pdf`);

  }

  return (
    <>
      <Header />
      {user.usuarios_permisos ? (
        <div className="card container col-sm-11">
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <IcFileInvoiceDollar style={{ marginRight: 8, color: "#3b82f6" }} />
                Cargos
              </h3>
              <p className="page-subtitle">Registro de cargos por cliente</p>
            </div>
            <div className="page-actions">
              {user.usuarios_permisos ? (
                <Button size="sm" color="success" onClick={toggleCreate}>
                  <IcPlus style={{ marginRight: 6 }} />
                  Nuevo Cargo
                </Button>
              ) : (
                <Button size="sm" color="success" disabled>
                  <IcPlus style={{ marginRight: 6 }} />
                  Nuevo Cargo
                </Button>
              )}
              <Button size="sm" color="secondary" href="/ReporteCargos" title="Ver reporte analítico por categoría">
                <IcChartPie style={{ marginRight: 5 }} />
                Reporte
              </Button>
              <ButtonGroup>
                <Button size="sm" color="danger" onClick={PDFTabla}>PDF <IcPdf /></Button>
                <Button size="sm" color="info" onClick={toggleMail}>eMail <IcAt /></Button>
                <Button size="sm" color="primary" onClick={excel}>Excel <IcExcel /></Button>
              </ButtonGroup>
            </div>
          </div>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Cargos</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>

          {/* ── Summary cards ──────────────────────────────────────────── */}
          <div className="row mb-3 mt-1">
            {[
              { label: "Total cargos",   value: summaryStats.count,        sub: summaryStats.totalImporte,  icon: <IcFileInvoiceDollar />, color: "#3b82f6", bg: "#eff6ff" },
              { label: "Total cobrado",  value: summaryStats.totalAbonos,  sub: `${summaryStats.cobPct}% de cobranza`, icon: <IcCheckCircle />, color: "#10b981", bg: "#f0fdf4" },
              { label: "Saldo pendiente",value: summaryStats.totalSaldo,   sub: "Por cobrar",               icon: <IcHourglass />,         color: "#f59e0b", bg: "#fffbeb" },
              { label: "Eficiencia",     value: `${summaryStats.cobPct}%`, sub: "Cobranza global",          icon: <IcChartLine />,         color: summaryStats.cobColor, bg: summaryStats.cobBg },
            ].map((card, i) => (
              <div key={i} className="col-6 col-md-3 mb-2">
                <div style={{ background: "#fff", borderRadius: 14, padding: "16px 18px", boxShadow: "0 1px 4px rgba(0,0,0,0.07)", borderTop: `3px solid ${card.color}`, display: "flex", alignItems: "center", gap: 14, height: "100%" }}>
                  <div style={{ width: 46, height: 46, borderRadius: 12, background: card.bg, flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center", color: card.color }}>
                    {card.icon}
                  </div>
                  <div>
                    <div style={{ fontSize: "1.3rem", fontWeight: 800, color: "#0f172a", lineHeight: 1 }}>{card.value}</div>
                    <div style={{ fontSize: "0.67rem", fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.06em", marginTop: 4 }}>{card.label}</div>
                    <div style={{ fontSize: "0.72rem", color: card.color, fontWeight: 600, marginTop: 2 }}>{card.sub}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="filter-bar">
            <div>
              <Label>Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </div>
            <div>
              <Label>Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </div>
            <div>
              <Label>Categoría</Label>
              <Input
                bsSize="sm"
                type="select"
                style={{ minWidth: 130 }}
                value={selectedCategoria}
                onChange={(e) => {
                  setSelectedCategoria(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Todas</option>
                <option value="Mensualidad">Mensualidad</option>
                <option value="Setup">Setup</option>
                <option value="Complemento">Complemento</option>
                <option value="Otros">Otros</option>
              </Input>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-6 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Table size="sm" striped borderless className="table-responsive-xl table-dark-header">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tr>
              <td></td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedCliente}
                  required
                  onChange={(e) => {
                    setSelectedCliente(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {clientes
                    .sort((a, b) =>
                      a.nombre_comercial > b.nombre_comercial ? 1 : -1
                    )
                    .map((a) => (
                      <option key={a._id} value={a._id}>{a.nombre_comercial}</option>
                    ))}
                </Input>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tbody>
              {commentsData.map((c) => {
                total        += c.importe;
                totalAbonos  += c.abonos;
                totalSaldo   += c.saldo;
                const saldoPendiente = Number(c.saldo) || 0;
                return (
                  <tr key={c._id}>
                    <td>{c.fecha}</td>
                    <td>{c.cliente}</td>
                    <td>
                      <span style={{
                        display: "inline-block",
                        padding: "2px 8px",
                        borderRadius: 12,
                        fontSize: "0.72rem",
                        fontWeight: 600,
                        background: c.categoria === "Mensualidad" ? "#dcfce7" : c.categoria === "Setup" ? "#dbeafe" : c.categoria === "Complemento" ? "#fef9c3" : "#f1f5f9",
                        color:      c.categoria === "Mensualidad" ? "#15803d"  : c.categoria === "Setup" ? "#1d4ed8"  : c.categoria === "Complemento" ? "#854d0e"  : "#475569",
                      }}>
                        {c.categoria || "Otros"}
                      </span>
                    </td>
                    <td>{"$" + new Intl.NumberFormat("en-US").format(c.importe)}</td>
                    <td>{"$" + new Intl.NumberFormat("en-US").format(c.abonos)}</td>
                    <td style={{ fontWeight: saldoPendiente > 0 ? 600 : "normal", color: saldoPendiente > 0 ? "#f59e0b" : "#64748b" }}>
                      {"$" + new Intl.NumberFormat("en-US").format(saldoPendiente)}
                    </td>
                    <td>
                      <div style={{ display: "flex", gap: 4 }}>
                        {user.usuarios_permisos && (
                          <Button
                            size="sm"
                            color="info"
                            onClick={() => jalaInfo(c._id, c.cliente)}
                            title="Editar cargo"
                          >
                            <IcEdit />
                          </Button>
                        )}
                        <Button
                          size="sm"
                          color="success"
                          onClick={() => abrirModalAbonar(c)}
                          title="Registrar abono"
                          disabled={saldoPendiente <= 0}
                        >
                          <IcDollar />
                        </Button>
                        <Button
                          size="sm"
                          color="danger"
                          onClick={() => PDFOC(c.fecha, c.cliente, c.importe, c.numero)}
                          title="Descargar PDF"
                        >
                          <IcPdf />
                        </Button>
                      </div>
                    </td>
                  </tr>
                );
              })}
              <tr style={{ borderTop: "2px solid #e2e8f0", fontWeight: 700 }}>
                <td></td>
                <td align="center" style={{ color: "#475569", fontSize: "0.72rem", textTransform: "uppercase", letterSpacing: "0.05em" }}>
                  TOTAL
                </td>
                <td></td>
                <td>{"$" + new Intl.NumberFormat("en-US").format(total)}</td>
                <td>{"$" + new Intl.NumberFormat("en-US").format(totalAbonos)}</td>
                <td style={{ color: totalSaldo > 0 ? "#f59e0b" : "#64748b" }}>
                  {"$" + new Intl.NumberFormat("en-US").format(totalSaldo)}
                </td>
                <td></td>
              </tr>
            </tbody>
          </Table>

          <Pagination
            total={totalItems}
            itemsPerPage={ITEMS_PER_PAGE}
            currentPage={currentPage}
            onPageChange={(page) => setCurrentPage(page)}
          />
        </div>
      ) : undefined}
      <Modal size="lg" isOpen={modalEdit} toggle={toggleEdit}>
        <ModalHeader toggle={toggleEdit}>
          <h4>
            <IcFileInvoiceDollar style={{ marginRight: 8, color: "#3b82f6" }} />
            Editar Cargo
          </h4>
        </ModalHeader>
        <ModalBody>
          <div className="form-section">
            <div className="form-section-header">
              <IcReceipt />
              <span className="form-section-title">Datos del Cargo</span>
            </div>
            <div className="form-section-body">
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label>Cliente</Label>
                    <Input type="text" value={clientesEdit} disabled style={{ background: "#f8fafc" }} />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label>Fecha</Label>
                    <Input type="date" value={fecha} required onChange={(e) => setFecha(e.target.value)} />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label>Importe</Label>
                    <Input type="number" placeholder="0.00" value={importe} required onChange={(e) => setImporte(e.target.value)} />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={8}>
                  <FormGroup>
                    <Label>Descripción</Label>
                    <Input type="text" placeholder="Descripción del cargo" value={descripcion} required onChange={(e) => setDescripcion(e.target.value)} />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label>Categoría</Label>
                    <Input type="select" value={categoriaEdit} required onChange={(e) => setCategoriaEdit(e.target.value)}>
                      <option value="Mensualidad">Mensualidad</option>
                      <option value="Setup">Setup</option>
                      <option value="Complemento">Complemento</option>
                      <option value="Otros">Otros</option>
                    </Input>
                  </FormGroup>
                </Col>
              </Row>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editCargo} disabled={!validaBoton}>
            <IcSave style={{ marginRight: 6 }} />
            Guardar Cambios
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
        <ModalHeader toggle={toggleProgreso}>
          <h4>Progreso</h4>
        </ModalHeader>
        <ModalBody>
          Cargando...
          <br />
          Por favor no cierre ni refresque su navegador.
          <br />
          <div className="divPadre2">
            <div className="divHijo2">
              <Spinner
                style={{ width: "3rem", height: "3rem", color: "#232B41" }}
              />
              <Spinner
                style={{ width: "3rem", height: "3rem", color: "#232B41" }}
              />
              <Spinner
                style={{ width: "3rem", height: "3rem", color: "#232B41" }}
              />
            </div>
          </div>
        </ModalBody>
      </Modal>
      {/* Modal: Registrar Abono rápido */}
      <Modal size="sm" isOpen={modalAbonar} toggle={toggleAbonar}>
        <ModalHeader toggle={toggleAbonar}>
          Registrar Abono
        </ModalHeader>
        <ModalBody>
          {abonarCargo && (
            <>
              <div style={{ marginBottom: 14, padding: "10px 14px", background: "#f8fafc", borderRadius: 8, fontSize: "0.82rem" }}>
                <div style={{ fontWeight: 600, color: "#0f172a" }}>{abonarCargo.cliente}</div>
                <div style={{ color: "#64748b" }}>Cargo: {new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN" }).format(abonarCargo.importe)}</div>
                {abonarCargo.saldo !== abonarCargo.importe && (
                  <div style={{ color: "#f59e0b", fontSize: "0.77rem" }}>
                    Saldo pendiente: {new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN" }).format(abonarCargo.saldo)}
                  </div>
                )}
              </div>
              <Row>
                <Col md={12}>
                  <Label>Fecha</Label>
                  <Input
                    bsSize="sm"
                    type="date"
                    value={abonarFecha}
                    onChange={(e) => setAbonarFecha(e.target.value)}
                    required
                  />
                </Col>
              </Row>
              <Row className="mt-2">
                <Col md={12}>
                  <Label>Importe</Label>
                  <Input
                    bsSize="sm"
                    type="number"
                    value={abonarImporte}
                    onChange={(e) => setAbonarImporte(e.target.value)}
                    required
                  />
                </Col>
              </Row>
              <Row className="mt-2">
                <Col md={12}>
                  <Label>Forma de pago</Label>
                  <Input
                    bsSize="sm"
                    type="select"
                    value={abonarFormaPago}
                    onChange={(e) => setAbonarFormaPago(e.target.value)}
                  >
                    <option>Efectivo</option>
                    <option>Transferencia</option>
                    <option>Tarjeta</option>
                    <option>Cheque</option>
                  </Input>
                </Col>
              </Row>
            </>
          )}
        </ModalBody>
        <ModalFooter>
          {validaBoton ? (
            <Button color="success" onClick={guardarAbono}>
              Guardar abono
            </Button>
          ) : (
            <Button color="success" disabled>
              Guardando...
            </Button>
          )}
        </ModalFooter>
      </Modal>

      {/* ── Modal Nuevo Cargo ────────────────────────────────────────── */}
      <Modal size="lg" isOpen={modalCreate} toggle={toggleCreate}>
        <ModalHeader toggle={toggleCreate}>
          <IcFileInvoiceDollar style={{ marginRight: 8, color: "#3b82f6" }} />
          Nuevo Cargo
        </ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-md-6">
              <FormGroup>
                <Label>Cliente <span style={{ color: "#ef4444" }}>*</span></Label>
                <Input type="select" value={cCliente} onChange={(e) => setCCliente(e.target.value)} required
                  style={{ height: 31, fontSize: "0.875rem", padding: "0.25rem 0.5rem", color: "#0f172a" }}>
                  <option value="">Selecciona un cliente</option>
                  {clientes.filter((c) => c.is_active === "Si").sort((a, b) => a.nombre_comercial > b.nombre_comercial ? 1 : -1).map((c) => (
                    <option key={c._id} value={c._id}>{c.nombre_comercial}</option>
                  ))}
                </Input>
              </FormGroup>
            </div>
            <div className="col-md-6">
              <FormGroup>
                <Label>Fecha <span style={{ color: "#ef4444" }}>*</span></Label>
                <Input bsSize="sm" type="date" value={cFecha} onChange={(e) => setCFecha(e.target.value)} required />
              </FormGroup>
            </div>
            <div className="col-md-6">
              <FormGroup>
                <Label>Importe <span style={{ color: "#ef4444" }}>*</span></Label>
                <Input bsSize="sm" type="number" min="0" step="any" value={cImporte} onChange={(e) => setCImporte(e.target.value)} required />
              </FormGroup>
            </div>
            <div className="col-md-6">
              <FormGroup>
                <Label>Categoría</Label>
                <Input type="select" value={cCategoria} onChange={(e) => setCCategoria(e.target.value)}
                  style={{ height: 31, fontSize: "0.875rem", padding: "0.25rem 0.5rem", color: "#0f172a" }}>
                  <option value="Mensualidad">Mensualidad</option>
                  <option value="Setup">Setup</option>
                  <option value="Complemento">Complemento</option>
                  <option value="Otros">Otros</option>
                </Input>
              </FormGroup>
            </div>
            <div className="col-md-12">
              <FormGroup>
                <Label>Descripción <span style={{ color: "#ef4444" }}>*</span></Label>
                <Input bsSize="sm" type="text" value={cDescripcion} onChange={(e) => setCDescripcion(e.target.value)} required />
              </FormGroup>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={saveCargo}>
            <IcSave style={{ marginRight: 6 }} /> Guardar
          </Button>
          <Button color="secondary" onClick={toggleCreate}>Cancelar</Button>
        </ModalFooter>
      </Modal>

      {loader}
    </>
  );
}

export default ListadoCargos;
